import styles from './styles.module.css'

const Checkbox = (props) => {
  const elementProps = {
    type: 'checkbox',
    ...props
  }

  return <input {...elementProps} className={styles.ecCheckbox} />
}

export default Checkbox
